import React, { useState, useEffect, useMemo } from "react";
import config from "../../coreFIles/config";
import { toast, Toaster } from "react-hot-toast";
import CryptoJS from 'crypto-js';
import {
  getPropertyDetailAction,
  getMMGJwtForApp
} from "../../Action/user.action";
import { paymentIntentAction } from "../../Action/propertyOwner.action";
import {
  Container,
  Row,
  Col,
  Card,
} from "react-bootstrap";
import { Buffer } from "buffer";
import { loadStripe } from "@stripe/stripe-js";
import moment from "moment";

const AppPayment = () => {

  const url = window.location.href;
  const urlParams = new URL(url);
  const params = new URLSearchParams(urlParams.search);
  const id = params.get('id');
  const numberOfAdults = params.get('numberOfAdults');
  const checkin = params.get('checkin');
  const checkout = params.get('checkout');
  const numberOfChildren = params.get('numberOfChildren');
  const numberOfInfants = params.get('numberOfInfants');
  const numberOfPets = params.get('numberOfPets');
  const roomType = params.get('roomType');
  const JWT = params.get('JWT');

  const [leaseCount, setleaseCount] = useState({
    years: 0,
    months: 1,
  });

  const [propertyDetail, setpropertyDetail] = useState({
    PropertyName: "",
    amenityArr: [],
    bikeParking: "",
    carParking: "",
    categoryName: "",
    checkIn: "",
    checkOut: "",
    datetime: "",
    description: "",
    documentArr: [],
    email: "",
    guestCount: "",
    id: "",
    imageArr: [],
    isDeleted: "",
    location: "",
    numberOfBathroom: "",
    numberOfBedrooms: "",
    numberOfBeds: "",
    petsAllowed: "",
    price: "",
    propertyName: "",
    propertyPurchaseType: "",
    propertyPurchaseTypeId: "",
    status: "",
    terms: "",
  });
  const [imagesArr, setimagesArr] = useState([]);
  const [amenityArr, setAmenityArr] = useState([]);
  const [fygaroToken, setFygaroToken] = useState('');
  const [totalBookingDay, settotalBookingDay] = useState(0);
  const [paymentType, setpaymentType] = useState(1); //1=Card ,2=Bank Transfer ,3=Paypal,4=Stripe,5=MMG
  const [clientSecret, setClientSecret] = useState("");
  const [chooseplanDetails, setChoosePlanDetails] = useState({
    description: "",
  });
  const [totalAmount, settotalAmount] = useState(0);
  const [orderAmount, setorderAmount] = useState(0);
  const [roomPrice, setRoomPrice] = useState(0);

  useEffect(() => {
    getListingDetails();
  }, []);

  useEffect(() => {
    if (totalAmount > 0) {
      getFygaroPayloadAPI(propertyDetail);
    }
  }, [totalAmount]);

  const getListingDetails = async () => {
    let res = await getPropertyDetailAction({ id: id, roomType: roomType });
    console.log("getPropertyDetailAction", res.data);
    let priceOfRoom = res.data?.price;
    if (res.success) {
      setpropertyDetail(res.data);

      let roomPriceRes = res.data.getPropertyRoomPrice;
      if (roomPriceRes.length > 0) {
        setRoomPrice(
          roomPriceRes[0]?.price ? roomPriceRes[0]?.price : res.data?.price
        );
        priceOfRoom = roomPriceRes[0]?.price
          ? roomPriceRes[0]?.price
          : res.data?.price;
      } else {
        setRoomPrice(res.data?.price);
      }

      setimagesArr(JSON.parse(res.data.imageArr));
      setAmenityArr(res.data.amenityArr);
    }
    if (checkin && checkout) {
      //Difference in number of days
      var date1 = new Date(checkin);
      var date2 = new Date(checkout);

      // To calculate the time difference of two dates
      var Difference_In_Time = date2.getTime() - date1.getTime();

      // To calculate the no. of days between two dates
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

      settotalBookingDay(Difference_In_Days);
      if (res.data?.propertyPurchaseTypeId == 2) {
        let totalRoomPrice =
          (parseFloat(numberOfAdults) / 2 - parseInt(numberOfAdults / 2) > 0
            ? parseInt(parseFloat(numberOfAdults) / 2) + 1
            : parseFloat(numberOfAdults) / 2) *
          parseFloat(priceOfRoom) *
          Difference_In_Days;
        const securityDeposit = parseFloat(res.data?.securityDeposit ?? 0);
        const cleaningAndMaintenanceFee = parseFloat(res?.data?.cleaningAndMaintenanceFee ?? 0);
        const taxPercentage = parseFloat(res.data?.taxPercentage ?? 0);
        settotalAmount(
          totalRoomPrice + securityDeposit + cleaningAndMaintenanceFee + (totalRoomPrice * taxPercentage) / 100

        );
      } else if (res.data?.propertyPurchaseTypeId == 1) {
        settotalAmount(parseFloat(priceOfRoom));
      } else {

        const cleaningAndMaintenanceFee = parseFloat(
          res?.data?.cleaningAndMaintenanceFee ?? 0
        );
        const securityDeposit = parseFloat(res.data?.securityDeposit ?? 0);
        const price = parseFloat(res.data?.price ?? 0);
        const taxPercentage = parseFloat(res.data?.taxPercentage ?? 0);
        const leasePeriod = parseInt(
          leaseCount[res.data.priceType ? "years" : "months"] ?? 0
        );
        const numberOfAdultsParsed = parseFloat(numberOfAdults ?? 0);

        const baseAmount = price * leasePeriod * numberOfAdultsParsed;
        const taxAmount = (baseAmount * taxPercentage) / 100;

        const totalAmount =
          cleaningAndMaintenanceFee + securityDeposit + baseAmount + taxAmount;

        settotalAmount(totalAmount);
      }
    }
  };



  const getFygaroPayloadAPI = async (data) => {
    const encryptionKey = config.fygaroJWTEncryptionKey;

    const numOfAdults = parseInt(numberOfAdults, 10) || 0;
    const roomPriceNum = parseFloat(roomPrice) || 0;
    const taxPercentageNum = parseFloat(data.taxPercentage) || 0;

    const halfAdultsRoundedUp = Math.ceil(numOfAdults / 2);

    var date1 = new Date(checkin);
    var date2 = new Date(checkout);

    var Difference_In_Time = date2.getTime() - date1.getTime();

    var bookingDays = Difference_In_Time / (1000 * 3600 * 24);

    const taxAmountCalculate = (halfAdultsRoundedUp * roomPriceNum * bookingDays * taxPercentageNum) / 100;


    let fygaroPayload = {
      id,
      amount: totalAmount,
      //amount: 1,
      numberOfAdults,
      checkin,
      checkout,
      numberOfChildren,
      numberOfInfants,
      numberOfPets,
      roomType,
      //  numberOfRooms: data.,
      cleaningAndMaintenanceFee: data.cleaningAndMaintenanceFee ? data.cleaningAndMaintenanceFee : 0,
      taxAmount: taxAmountCalculate,
      securityDeposit: data.securityDeposit,
      PetsAmountTotal: data?.petsPrice && numberOfPets > 0
        ? parseInt(numberOfPets) * parseFloat(data?.petsPrice)
        : 0,
      type: 1
    };

    console.log('fygaroPayload', fygaroPayload)
    console.log('taxAmountCalculate', taxAmountCalculate)
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(fygaroPayload),
      encryptionKey
    ).toString();

    let jwtReceived = await getMMGJwtForApp({ jwt: encryptedPayload, auth: JWT });

    if (jwtReceived.success) {
      console.log('jwtReceived', jwtReceived.data)
      setFygaroToken(jwtReceived.data);
    }
  };


  const paymentIntent = async () => {
    let amount = totalAmount;

    let res = await paymentIntentAction({ amount: amount });
    if (res.success) {
      setClientSecret({
        clientSecret: Buffer.from(res.client_secret, "base64").toString(
          "ascii"
        ),
      });
    }
  };

  const onError = (data, actions) => {
    toast.error(
      "Something went wrong with your payment. Please try again after some time"
    );
  };

  const disableStripe = () => {
    setClientSecret("");
  };

  useMemo(() => {
    if (paymentType == 2) {
      paymentIntent();
    }
  }, [paymentType]);

  const callFygaro = () => {
    if (fygaroToken) {
      let fygaroString = `https://www.fygaro.com/en/pb/8ef036d5-3406-4b0d-858f-8d814667d469?jwt=${fygaroToken}`;
      window.open(fygaroString, '_blank');
    } else {
      toast.error('Something went wrong please try again after some time.');
    }
  };

  return (
    <>
      <Toaster />
      <section className="yourbooking pt-5 pb-5 overflow-hidden vh-80">
        <Container>
          <div className="">
            <Row className=" ">
              <Col lg={12} className="mb-4">
                <Card>
                  <div className="paymentImg">
                    {imagesArr.length > 0 ? (
                      <img src={imagesArr[0].fileNameImage} />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="px-2">
                    <div>
                      <div className="mt-4">
                        <div className="">
                          <h5 className="mb-2">
                            <b>{propertyDetail.propertyName}</b>
                          </h5>
                          <div className="d-flex justify-content-between">
                            <div>
                              <h6>{propertyDetail.location}</h6>
                            </div>
                            {propertyDetail?.propertyPurchaseTypeId !== 2 ? (
                              <h5>
                                {" "}
                                <b>${totalAmount}</b>
                              </h5>
                            ) : (
                              ""
                            )}
                          </div>
                          {propertyDetail?.propertyPurchaseTypeId == 2 ? (
                            <div>
                              <p className="text-grey mb-0">
                                {moment(new Date()).format("YYYY-MM-DD")}
                              </p>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <hr />

                      {propertyDetail?.propertyPurchaseTypeId == 2 ? (
                        <>
                          <div className="">
                            <Row>
                              <Col lg={4} className="">
                                <div>
                                  <div>
                                    <b>Check-in</b>
                                  </div>
                                  <p className="text-grey mb-0">{checkin}</p>
                                </div>
                              </Col>
                              <Col lg={4} className="">
                                <div>
                                  <div>
                                    <b>Checkout</b>
                                  </div>
                                  <p className="text-grey mb-0">{checkout}</p>
                                </div>
                              </Col>
                              <Col lg={4} className="">
                                <div>
                                  <div>
                                    <b>Guests</b>
                                  </div>
                                  <p className="text-grey mb-0">
                                    {numberOfAdults} Adult, {numberOfChildren}{" "}
                                    Children, {numberOfInfants} Infants,{" "}
                                    {numberOfPets} Pets
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </div>
                          <hr />
                          <div className="mt-4 mb-1">
                            <Row>
                              <Col lg={6} sm={6} xs={6} className="mb-2">
                                <h6>
                                  <td>
                                    {" "}
                                    {parseFloat(numberOfAdults) / 2 -
                                      parseInt(numberOfAdults / 2) >
                                      0
                                      ? parseInt(
                                        parseFloat(numberOfAdults) / 2
                                      ) + 1
                                      : parseFloat(numberOfAdults) / 2}{" "}
                                    Beds X {parseFloat(roomPrice)} Price X{" "}
                                    {totalBookingDay} Nights
                                  </td>
                                </h6>
                              </Col>
                              <Col
                                lg={6}
                                sm={6}
                                xs={6}
                                className="mb-2 text-right"
                              >
                                <span className="text-grey">
                                  $
                                  {(parseFloat(numberOfAdults) / 2 -
                                    parseInt(numberOfAdults / 2) >
                                    0
                                    ? parseInt(parseFloat(numberOfAdults) / 2) +
                                    1
                                    : parseFloat(numberOfAdults) / 2) *
                                    parseFloat(roomPrice) *
                                    totalBookingDay}
                                </span>
                              </Col>
                              <Col lg={6} sm={6} xs={6} className="mb-2">
                                <h6>Cleaning and service fee</h6>
                              </Col>
                              <Col
                                lg={6}
                                sm={6}
                                xs={6}
                                className="mb-2 text-right"
                              >
                                <span className="text-grey">
                                  + $
                                  {propertyDetail?.cleaningAndMaintenanceFee
                                    ? propertyDetail?.cleaningAndMaintenanceFee
                                    : 0}
                                </span>
                              </Col>
                              <Col lg={6} sm={6} xs={6} className="mb-2">
                                <h6>Pets Amount</h6>
                              </Col>
                              <Col
                                lg={6}
                                sm={6}
                                xs={6}
                                className="mb-2 text-right"
                              >
                                <span className="text-grey">
                                  + $
                                  {parseFloat(
                                    propertyDetail?.petsPrice &&
                                      numberOfPets > 0
                                      ? parseInt(numberOfPets) *
                                      parseFloat(propertyDetail?.petsPrice)
                                      : 0
                                  )}
                                </span>
                              </Col>

                              <Col lg={6} sm={6} xs={6} className="mb-2">
                                <h6>Taxes</h6>
                              </Col>
                              <Col
                                lg={6}
                                sm={6}
                                xs={6}
                                className="mb-2 text-right"
                              >
                                <span className="text-grey">
                                  + $
                                  {propertyDetail?.taxPercentage
                                    ? ((parseFloat(numberOfAdults) / 2 -
                                      parseInt(numberOfAdults / 2) >
                                      0
                                      ? parseInt(
                                        parseFloat(numberOfAdults) / 2
                                      ) + 1
                                      : parseFloat(numberOfAdults) / 2) *
                                      parseFloat(roomPrice) *
                                      totalBookingDay *
                                      parseFloat(
                                        propertyDetail?.taxPercentage
                                      )) /
                                    100
                                    : 0}
                                </span>
                              </Col>

                              <Col lg={6} sm={6} xs={6} className="mb-2">
                                <h6>Security Deposit</h6>
                              </Col>
                              <Col
                                lg={6}
                                sm={6}
                                xs={6}
                                className="mb-2 text-right"
                              >
                                <span className="text-grey">
                                  + ${propertyDetail?.securityDeposit}
                                </span>
                              </Col>

                              <Col lg={6} sm={6} xs={6} className="mb-2 ">
                                <h5>
                                  <b>Total Cost:</b>
                                </h5>
                              </Col>
                              <Col
                                lg={6}
                                sm={6}
                                xs={6}
                                className="mb-2 text-right"
                              >
                                <h5 className="fw-bold">
                                  $
                                  {(parseFloat(numberOfAdults) / 2 -
                                    parseInt(numberOfAdults / 2) >
                                    0
                                    ? parseInt(parseFloat(numberOfAdults) / 2) +
                                    1
                                    : parseFloat(numberOfAdults) / 2) *
                                    parseFloat(roomPrice) *
                                    totalBookingDay +
                                    (propertyDetail?.taxPercentage
                                      ? ((parseFloat(numberOfAdults) / 2 -
                                        parseInt(numberOfAdults / 2) >
                                        0
                                        ? parseInt(
                                          parseFloat(numberOfAdults) / 2
                                        ) + 1
                                        : parseFloat(numberOfAdults) / 2) *
                                        parseFloat(roomPrice) *
                                        totalBookingDay *
                                        parseFloat(
                                          propertyDetail?.taxPercentage
                                        )) /
                                      100
                                      : 0) +
                                    parseFloat(
                                      propertyDetail?.cleaningAndMaintenanceFee &&
                                        numberOfAdults > 0
                                        ? propertyDetail?.cleaningAndMaintenanceFee
                                        : 0
                                    ) +
                                    parseFloat(
                                      propertyDetail?.petsPrice &&
                                        numberOfPets > 0
                                        ? parseInt(numberOfPets) *
                                        parseFloat(
                                          propertyDetail?.petsPrice
                                        )
                                        : 0
                                    ) +
                                    parseFloat(propertyDetail?.securityDeposit)}
                                </h5>
                              </Col>
                            </Row>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </Card>
                {/* <button className="btn paypal-button w-100 mt-2" onClick={callFygaro}>Pay Now</button> */}
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default AppPayment;
